import { ExcludeCategoryFilterKey } from "app/pages/sales-intelligence/sub-modules/advanced-search/types/filters-keys";
import type {
    ExcludeListDuplicateOpportunitiesKey,
    ExcludeListsAvailability,
    ExcludeListsDuplicateOpportunities,
    ExcludeListsDuplicateOpportunitiesResponseDto,
    ListDuplicatesDto,
} from "app/pages/sales-intelligence/sub-modules/opportunities/types";
import { is } from "app/pages/sales-intelligence/utils/type-guards";

const ExcludeListsDuplicatesToFiltersMap = {
    salesforceListsDuplicates: ExcludeCategoryFilterKey.Salesforce,
    hubspotListsDuplicates: ExcludeCategoryFilterKey.Hubspot,
    suppressionListsDuplicates: ExcludeCategoryFilterKey.SuppressionListIds,
    similarwebListsDuplicates: ExcludeCategoryFilterKey.StaticListsToExclude,
};

const listHasDuplicates = (list: ListDuplicatesDto): boolean => {
    return list.totalCount >= 1;
};

const listHasMatchingExcludeFilter = (
    dtoListName: ExcludeListDuplicateOpportunitiesKey,
    excludeIntegrationFiltersAvailability: ExcludeListsAvailability,
): boolean => {
    const filterKey = ExcludeListsDuplicatesToFiltersMap[dtoListName];
    return excludeIntegrationFiltersAvailability[filterKey] ?? true;
};

const getAvailableExcludeListsNames = (
    duplicatesListsDto: Omit<ExcludeListsDuplicateOpportunitiesResponseDto, "distinctDuplicatesCount">,
    excludeIntegrationFiltersAvailability: ExcludeListsAvailability,
): readonly ExcludeListDuplicateOpportunitiesKey[] => {
    const listsKeys = Object.keys(duplicatesListsDto) as ExcludeListDuplicateOpportunitiesKey[];

    return listsKeys.filter(
        (dtoListName) =>
            listHasDuplicates(duplicatesListsDto[dtoListName]) &&
            listHasMatchingExcludeFilter(dtoListName, excludeIntegrationFiltersAvailability),
    );
};

export const buildExcludeListsFromExcludeFilters = (
    duplicatesListsDto: ExcludeListsDuplicateOpportunitiesResponseDto | undefined,
    excludeIntegrationFiltersAvailability: ExcludeListsAvailability,
): ExcludeListsDuplicateOpportunities["lists"] => {
    if (is.undefined(duplicatesListsDto)) {
        return [];
    }

    const { distinctDuplicatesCount, ...duplicatesLists } = duplicatesListsDto;

    const availableExcludeListsNames = getAvailableExcludeListsNames(
        duplicatesLists,
        excludeIntegrationFiltersAvailability,
    );

    return availableExcludeListsNames.map((dtoListName) => ({
        listType: ExcludeListsDuplicatesToFiltersMap[dtoListName],
        duplicatesCount: duplicatesLists[dtoListName].totalCount,
    }));
};
